var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67507 22.3393L2.34174 18.5298C1.52059 17.9432 1.11002 17.65 0.888352 17.2192C0.666687 16.7885 0.666687 16.2839 0.666687 15.2748V8.7251C0.666687 8.40375 0.666687 8.13357 0.673845 7.90064L9.00002 13.8479V23.2313C8.64327 23.0309 8.22701 22.7335 7.67507 22.3393ZM11 23.2313C11.3568 23.0309 11.773 22.7335 12.325 22.3393L17.6583 18.5298C18.4795 17.9432 18.89 17.65 19.1117 17.2192C19.3334 16.7885 19.3334 16.2839 19.3334 15.2748V8.72509C19.3334 8.40375 19.3334 8.13356 19.3262 7.90064L11 13.8479V23.2313ZM18.4609 6.06089L10 12.1044L1.53913 6.06089C1.75041 5.89253 2.01321 5.70482 2.34173 5.47016L2.34174 5.47016L7.67507 1.66064C8.79775 0.858721 9.35909 0.457764 10 0.457764C10.641 0.457764 11.2023 0.858722 12.325 1.66064L17.6583 5.47016C17.9868 5.70482 18.2496 5.89253 18.4609 6.06089Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.e4691d1d1ab2f78265478dc23b0906c9.svg";
export { ForwardRef as ReactComponent };